import { useMenuState } from "reakit/Menu";

export const useDropdownMenuState = () => useMenuState({ animated: true, modal: true });
